import Http from "../http";

class AdminServices {

  /* ================= LOGIN ================= */
  static async login(data) {
    return Http.post("/login", data);
  }

  /* ================= GET ALL ADMINS ================= */
  static async getAllAdmins() {
    return Http.get("/admins");
  }

  /* ================= CREATE ADMIN ================= */
  static async createAdmin(data) {
    return Http.post("/admins/create", data);
  }

  /* ================= UPDATE ADMIN ================= */
  static async updateAdmin(id, data) {
    return Http.update(`/admins/${id}`, data);
  }
}

export default AdminServices;
